<div class="my-5">
  <div class="card">
    <h3 class="card-title">{{ 'ultimos-cambios.titulo' | translate }}</h3>
    <div class="card-body">
      <!-- Mostrar párrafo informativo si el arreglo está vacío -->
      <p *ngIf="cambios.length === 0" class="text-muted">
        {{ 'ultimos-cambios.no-hay-cambios' | translate }}
      </p>
      <!-- Mostrar lista si hay elementos -->
      <ul *ngIf="cambios.length > 0" class="list-group">
        <li *ngFor="let cambio of cambios" class="list-group-item">
          <i
            [ngClass]="getIconClass(cambio.transaccion!)"
            aria-hidden="true"></i>
          <p>
            {{
              formatTransaccion(cambio.transaccion!, cambio.Valor_modificado!)
            }}
          </p>
          <br />
        </li>
      </ul>
    </div>
  </div>
</div>
